import { createContext, useContext } from "react";
import { MessageChangeEvent } from "@/lib/message";

interface ChatContextType {
  onMessageChange: (messageChangeEvent: MessageChangeEvent) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const useChatContext = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
};

export const ChatProvider = ChatContext.Provider;
